import React from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import callApi from '../../utils/callApi';
import {
  ANCHOR_VIEW,
  NNLIVE_VIEW,
} from '../../constants/apiUrls/apiUrls';
import AnchorStore from '../../store/AnchorStore';
import GroupShowStore from '../../store/GroupShowStore';
import { fetchGalleriesAndVideosCountForBio } from '../../utils/helpers';
import './css/Anchor.css';
import '../../css/utils/flex.css';
import FullLoader from '../../components/Loaders/FullLoader';
import { RootStoreContext } from '../../context';
import LiveBroadcastStore from '../../store/LiveBroadcastStore';
import TulumRealityShowStore from '../../store/TulumRealityShowStore';


const AnchorPageComponents = React.lazy(() => import('./AnchorPageComponents'));
const NakedNewsLivePage = React.lazy(() => import('./NakedNewsLivePage'));

@observer
class AnchorPage extends React.Component {
  static contextType = RootStoreContext;
  state = {
    anchor: null,
    nakedNewsLiveAnchorData: null,
    anchorId: null,
    itemCount: 0,
    showContextualOverlay: false,
    videosCount: 0,
    galleriesCount: 0,
    publicShowsCount: 0,
    isBanned: false,
    nakedNewsLivePromoClip: null,
    nakedNewsLivePromoImage: null,
    livePageAdData: {},
    isLoading: true,
  };

  componentDidMount() {
    const anchorId = this.extractIdFromSlug();
    fetchGalleriesAndVideosCountForBio(anchorId, this.setGalleriesAndVideo);
    this.fetchAnchor(anchorId);
    AnchorStore.setAnchors();
  }

  componentWillUnmount() {
    const { tippingStore } = this.context;
    tippingStore.resetTippingAnchors();
    AnchorStore.setIsAnchorLive(undefined);
    GroupShowStore.setInGroupShow(false);
    LiveBroadcastStore.reset();
    TulumRealityShowStore.reset();
    LiveBroadcastStore.setAnchorId(null);
  }

  setNakedNewsLivePageAd = (data) => {
    this.setState({ livePageAdData: data });
  };

  setItemsCount = (value) => {
    this.setState({ itemCount: value });
  };

  getTemptedNNLData = () => callApi(NNLIVE_VIEW, 'get', {});

  getAnchorData = (id) => callApi(ANCHOR_VIEW.replace('{id}', id), 'get', {});

  setNNLData = (data) => {
    this.setState({ nakedNewsLiveAnchorData: data });
  };

  setAnchorData = (id, data) => {
    this.setState({
      anchorId: id,
      anchor: data,
      isLoading: false,
    }, () => this.setPageTitle());
    LiveBroadcastStore.fetchAnchorServicesUrls(data?.username);
    LiveBroadcastStore.setAnchorName(data?.username);
  };

  fetchAnchor = async(id) => {
    LiveBroadcastStore.setAnchorId(parseInt(id, 10));
    if (id === '241') {
      const [temptedData, anchorData] = await Promise.all([this.getTemptedNNLData(), this.getAnchorData(id)]);
      AnchorStore.setIsNakedNewsLive(true);
      this.setAnchorData(id, temptedData?.data);
      this.setNNLData(anchorData?.data);
    } else {
      const { data, error } = await this.getAnchorData(id);
      this.setAnchorData(id, data);
    }
  };

  setGalleriesAndVideo = (data) => {
    this.setState({
      videosCount: data.totalPublicVideos,
      galleriesCount: data.totalPublicGalleries,
      publicShowsCount: data.totalLiveShows,
    });
  };

  extractIdFromSlug = () => {
    const { slug, isLive } = this.props;
    const digitArray = slug?.match(/\d/g);

    return isLive ? '241' : digitArray.join('');
  };

  setPageTitle = () => {
    const { isLive } = this.props;
    const { anchor } = this.state;
    if (!isLive && !anchor) {
      return;
    }
    const page = isLive ? 'Live' : anchor?.name;
    document.title = `${page} | Naked News`;
  };

  setNakedNewsLivePromoUrl = (clipUrl, imageUrl) => {
    this.setState({
      nakedNewsLivePromoClip: clipUrl,
      nakedNewsLivePromoImage: imageUrl,
    });
  };

  setBanStatus = (value) => {
    this.setState({ isBanned: value });
  };

  toggleContextualJoinOverlay = (flag) => {
    this.setState({ showContextualOverlay: flag });
  };

  fetchStreamDetails = () => {
    this.fetchAnchor(this.state.anchorId);
  };

  onNetworkError = () => {
    const { anchor } = this.state;
    this.fetchAnchorServicesUrls(anchor.username);
  };

  render() {
    const {
      anchor,
      anchorId,
      itemCount,
      showContextualOverlay,
      isBanned,
      nakedNewsLivePromoClip,
      nakedNewsLivePromoImage,
      livePageAdData,
      nakedNewsLiveAnchorData,
      isLoading,
    } = this.state;
    const { slug, anchorPortalCampaign } = this.props;
    const {
      anchorVideoUrl,
      chatService,
      chatServiceTem,
      guestUser,
      isSpotlighing,
      spotlighedAnchorNickname,
      spotlighedAnchorUsername,
      userCanAccessSpecialEvent,
    } = LiveBroadcastStore;

    // commented out to allow guest and past anchors to stream
    // const isImageLayout = anchor.guest || !anchor.active ? true : false;
    let isImageLayout = false;

    if (anchorVideoUrl) {
      isImageLayout = false;
    } else if (anchor?.guest) {
      isImageLayout = false;
    } else {
      isImageLayout = !!(anchor?.guest || !anchor?.active);
    }
    const { location, user, history } = this.props;
    const isLivePage = slug === 'live' || (slug === 'home' && window.location.hostname.includes('nakednewslive'));
    const pageItemsShown = 9;

    const props = {
      anchor,
      anchorId,
      anchorVideoUrl,
      chatService,
      chatServiceTempted: chatServiceTem,
      extractIdFromSlug: this.extractIdFromSlug,
      fetchStreamDetails: this.fetchStreamDetails,
      guestUser,
      history,
      isBanned,
      toggleContextualJoinOverlay: this.toggleContextualJoinOverlay,
      showFanZone: anchor?.hasFanzone,
      slug,
      user,
      onNetworkError: this.onNetworkError,
      authenticated: user.authenticated,
      galleriesAndVideosCount: itemCount,
      isImageLayout,
      loggedInUsername: user.user ? user.user.username : '',
      promoThumbnail: anchor?.fanzonePromopic,
      promoVideo: anchor?.promoClip,
      totalGalleriesCount: this.state.galleriesCount,
      totalPublicShowsCount: this.state.publicShowsCount,
      totalVideosCount: this.state.videosCount,
      anchorPortalCampaign,
      showOverlay: showContextualOverlay,
      location,
      pageItemsShown,
      setBanStatus: this.setBanStatus,
      setItemsCount: this.setItemsCount,
      showClipStore: anchor?.showClipStore,
      isSpotlighing,
      spotlighedAnchorUsername,
      spotlighedAnchorNickname,
      nakedNewsLivePromoClip,
      nakedNewsLivePromoImage,
      livePageAdData,
      nakedNewsLiveAnchorData,
      setNakedNewsLivePageAd: this.setNakedNewsLivePageAd,
      setNakedNewsLivePromoUrl: this.setNakedNewsLivePromoUrl,
      userCanAccessSpecialEvent,
    };

    return (
      <div
        className={
          classnames(
            'current fanzone flex-1',
            {
              'past-anchors': !isLivePage && !anchor?.guest && !anchor?.active,
              'live-page-container': isLivePage,
            }
          )
        } id="anchors-show"
      >
        {
          isLoading &&
            <div style={{ position: 'absolute', width: '100vw', zIndex: 9999, backgroundColor: '#160722' }}>
              <FullLoader />
            </div>
        }{
          isLivePage &&
            <React.Suspense fallback={<FullLoader />}>
              <NakedNewsLivePage {...props} />
            </React.Suspense>
        }
        {
          !isLivePage &&
            <React.Suspense fallback={<FullLoader />}>
              <AnchorPageComponents {...props} />
            </React.Suspense>
        }
      </div>
    );
  }
}

export default AnchorPage;

